// Analytics Service for Ticket Window Interface
// Sends analytics events to https://event.zpbt.uk/send/com.zipabout.internal.analytics/

import { v4 as uuidv4 } from 'uuid';

const ANALYTICS_BASE_URL = 'https://event.zpbt.uk/send/com.zipabout.internal.analytics';

// Generate or retrieve persistent user ID
const getUserId = () => {
  let userId = localStorage.getItem('zipabout-user-id');
  if (!userId) {
    userId = uuidv4();
    localStorage.setItem('zipabout-user-id', userId);
  }
  return userId;
};

// Get channelId from URL query string
const getChannelId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('channelId') || 'unknown';
};

// Send analytics event
export const sendAnalyticsEvent = async (eventName, payload = {}) => {
  try {
    const userId = getUserId();
    const channelId = getChannelId();
    
    // Analytics payload structure
    const analyticsPayload = {
      zipaboutId: userId,
      eventDetail: {
        platform: "device",
        channelVersion: "1.0",
        channelName: channelId,
        channelId: channelId,
        interactive: true
      },
      payload: payload
    };

    const response = await fetch(`${ANALYTICS_BASE_URL}/${eventName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(analyticsPayload)
    });

    if (!response.ok) {
      console.warn(`Analytics event failed: ${response.status} ${response.statusText}`);
    } else {
      console.log(`Analytics event sent: ${eventName}`);
    }
  } catch (error) {
    console.error('Analytics error:', error);
    // Don't throw - analytics failures shouldn't break the app
  }
};

const analyticsService = { sendAnalyticsEvent };
export default analyticsService;
